<template>
    <form id="onboarding-de" class="wrapper tab-not-eligible" role="form" method="post">
        <header>
            <span class="new-headline-xlg text-centered">Haben Sie die Diagnose Typ-2-Diabetes?</span>
        </header>

        <div class="form-input-radio-button-wrapper-two-columns">
            <div 
                class="form-input-radio-button-big"
                id="yes"
                @click="chooseOption('Yes')"
                >
                <div class="form-input-radio-button-inner">
                    <figure class="form-input-radio-button-icon">
                        <span class="material-symbols-rounded">done</span>
                    </figure> 
                    <span class="label-static">Ja</span>
                </div>
            </div>
            
            <div 
                class="form-input-radio-button-big form-input-radio-button--danger"
                id="no"
                @click="chooseOption('No')"
                >
                <div class="form-input-radio-button-inner">
                    <figure class="form-input-radio-button-icon">
                        <span class="material-symbols-rounded">close</span>
                    </figure> 
                    <span class="label-static">Nein</span>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
    export default {
        methods: {
            chooseOption(selection) {
                if (selection === 'Yes') {
                    setTimeout(() => {
                        this.$emit('clicked', 'diagnose')
                    }, 250);
                }

                if (selection === 'No') {
                    setTimeout(() => {
                        this.$emit('clicked', 'not-eligible')
                    }, 250);
                }
            },
        }
    }
</script>